import {
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { queriesPayees } from "@query";
import { WSQueries } from "../../../../query/WSQuery";
import { ResourceHistory } from "../../../../shared/components/ResourceHistory";
import { usePayeeHistoryResources } from "../../hooks/usePayeeHistoryResources";
import { selectorPayeeDisplayName } from "../../../../shared/selectors/selectorPayeeDisplayName";
import { useXWingspanPayerId } from "./useXWingspanPayerId";
import { PAYEES_ROOT_PATH, useGoToPayeeDetails } from "../../utils";

export const RoutePayeeHistory: React.FC<
  RouteComponentProps<{ payeeId: string }>
> = ({
  match: {
    params: { payeeId }
  },
  history
}) => {
  const xWingspanAccount = useXWingspanPayerId();
  const queryPayee = queriesPayees.getPayee.useQuery({
    payeeId,
    xWingspanAccount
  });
  const goToPayeeDetails = useGoToPayeeDetails();
  const historyResources = usePayeeHistoryResources(payeeId);

  return (
    <WSPage>
      <WSQueries queries={{ queryPayee }}>
        {({ queryPayeeData: payee }) => (
          <>
            <WSPageToolbar
              title="Contractor history"
              breadcrumbs={[
                {
                  label: "Contractors",
                  onClick: () => {
                    history.push(PAYEES_ROOT_PATH);
                  }
                },
                {
                  label: selectorPayeeDisplayName(payee),
                  onClick: () => {
                    goToPayeeDetails(payeeId);
                  }
                },
                {
                  label: "Contractor history"
                }
              ]}
            />

            <WSGrid>
              <WSGrid.Item span={{ l: "8" }}>
                <WSList gap="2XL">
                  <ResourceHistory resources={historyResources} />
                </WSList>
              </WSGrid.Item>
            </WSGrid>
          </>
        )}
      </WSQueries>
    </WSPage>
  );
};
